/**
 *
 * @returns {import('../../types/store').InternalTokenStoreInterface}
 */
const build = (key) => {
    const map = new Map();
    const cache = {
        get: () => map.get(key),
        set: (tokens) => {
            map.set(key, tokens);
        },
        remove: () => map.delete(key),
    };

    return cache;
};

export default build;
